import DashHudsonCarousel from './DashHudsonCarousel';

export default DashHudsonCarousel;
